export enum Region {
  DEFAULT = 'default',
  CA = 'ca'
}
